import script from "./CodeSnippet.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeSnippet.vue?vue&type=script&setup=true&lang=ts"

import "./CodeSnippet.vue?vue&type=style&index=0&id=2190975c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2190975c"]])

export default __exports__